import styled from 'styled-components';
import { Button, ButtonProps } from './Button';
import { Icons } from '../type';

const Wrapper = styled.div`
  position: relative;
  display: flex;
`;

const Icon = styled.div<{ $icon: Icons }>`
  position: absolute;
  width: ${(props) => `5${props.theme.unit}`};
  height: ${(props) => `5${props.theme.unit}`};
  top: 50%;
  margin-top: ${(props) => `-2.5${props.theme.unit}`};
  left: ${(props) => `-1.5${props.theme.unit}`};
  background: ${(props) =>
    `url(${process.env.PUBLIC_URL}/images/${props.$icon}.webp) no-repeat`};
  background-size: contain;
  background-position: center center;
  z-index: 1;
`;

export const ButtonIcon = ({
  color,
  icon,
  children,
  disabled,
  onClick,
}: ButtonProps & { icon: Icons }) => {
  return (
    <Wrapper>
      <Icon $icon={icon} />
      <Button color={color} disabled={disabled} onClick={onClick} flex={true}>
        {children}
      </Button>
    </Wrapper>
  );
};
